import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';

import './polyfill';
import './gps';
import './graphql';
import './kakao';
import './inappbrowser';

// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';

// Import main app component
import App from '../app.f7.html';

window.app = new Framework7({
  root: '#app', // App root element
  component: App, // App main component
  id: 'app.tour.rest', // App bundle ID
  name: 'tour-app', // App name
  theme: 'auto', // Automatic theme detection

  // App routes
  routes: routes,


  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    iosOverlaysWebView: true,
    iosBackgroundColor: `#00000`,
    androidOverlaysWebView: false,    
  },
  touch: {
    fastClicks: false,
  },
  on: {
    init: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
      }
    },
  },
});
